const pubsub = (function(){
    let q = {},
        topics = {},
        subUid = -1;

    //发布消息
    q.publish = function(topic, args) {
        if(!topics[topic]) {return;}
        var subs = topics[topic],
            len = subs.length;
        while(len--) {
            subs[len].func(topic, args);
        }
        return this;
    };

    //订阅事件
    q.subscribe = function(topic, func) {
        topics[topic] = topics[topic] ? topics[topic] : [];
        var token = (++subUid).toString();
        topics[topic].push({
            token : token,
            func : func
        });
        return token;
    };

    // 称除事件
    q.remove = function(topic, token) {
        if(topics[topic] && topics[topic].length > 0){
            topics[topic].forEach(function(item, index) {
                if(item.token === token){
                    topics[topic].splice(index, 1);
                }
            });
        }
    }

    return q;
})();

export default pubsub;


// WEBPACK FOOTER //
// ./src/common/js/pubsub.js